export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_01_Loop.011806bb.mp4";